import { ParkService } from 'src/app/services/park.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import * as $ from 'jquery';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { facilityService } from 'src/app/services/facility.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppConstant } from 'src/app/config/app.constant';
import { SidenavService } from 'src/app/services/sidenav.service';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';
import { MeetingService } from 'src/app/services/meeting.service';

@Component({
  standalone: false,
  selector: 'app-view-meeting-room',
  templateUrl: './view-meeting-room.component.html',
  styleUrls: ['./view-meeting-room.component.scss']
})
export class ViewMeetingRoomComponent implements OnInit {
  @ViewChild('contentActivation', { static: false }) content: ElementRef;

  data: any;
  url: any = '';
  id: any;
  facilities: any = []
  type: any;
  actProp: boolean = true;
  underMaintainance: boolean = false;
  closeResult: string;
  isLoaded: boolean = false;
  ParkId: any;
  FacilityTypeId: any;
  enableSave: boolean = false;
  fileToUpload: FormData;
  uploadForm: FormGroup;
  MeetingRoomList: any = [];
  MeetingRoomId: any;
  ImageUploadResultt: any;
  MeetingRoomListUnderMaintaince: any = [];
  meetingRoomCreate: any;
  meetingRoomRemove: any;
  meetingRoomEdit: any;
  meetingRoomView: any;
  paymentStatus: string;
  meetingRoomName: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiSrvice: facilityService,
    private route: Router,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private parkSrv: ParkService,
    private sideNavService: SidenavService,
    private rolebasedactionService: RolebasedactionService,
    private meetingService: MeetingService,
  ) { }

  handleFileInput(event: any) {
    let formData: FormData = new FormData();
    for (let i = 0; i < event.target.files.length; i++) {
      const name = event.target.files[i].name;
      const lastDot = name.indexOf('.');
      const ext = name.substring(lastDot + 1).toLowerCase();
      console.log(ext);
      if (ext == 'png' || ext == 'jpg' || ext == 'jpeg') {
        if (event.target.files[i].name.size > 2097152) {
          return this.appStateSrv.showToast(
            'Image size must be less then 2MB'
          );
        }
        console.log("filename", event.target.files[i].name)
        formData.append("asset", event.target.files[i], event.target.files[i].name);
        this.fileToUpload = formData;
        this.uploadForm.patchValue({
          asset: event.target.files[i],
        });
        this.uploadForm.get('asset').updateValueAndValidity();

        this.apiSrvice.uploadImage(event).then((data) => {
          this.url = data;
          this.enableSave = true;
          this.appStateSrv.showToast('Image added successfully');
        });
      }
      else {
        return this.appStateSrv.showToast('Please upload a valid file in jpg/png format only');
      }
    }
  }

  loadForm() {
    this.uploadForm = this.formBuilder.group({
      asset: [''],
    });

  }

  selectedFacility() {
    this.route.navigate(['meeting-room/create-meeting-room']);
  }

  save() {
    const formData = new FormData();
    formData.append('Image', this.uploadForm.get('asset').value);
    formData.append('TypeId', this.id);
    this.apiSrvice.updateFaclitiesImage(formData).subscribe((res) => {
      this.ImageUploadResultt = res;
      this.route.navigate(['/facility'])
    });
  }

  ngOnInit() {
    this.meetingRoomCreate = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Create');
    this.meetingRoomRemove = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Remove');
    this.meetingRoomEdit = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Edit');
    this.meetingRoomView = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:View');
    this.loadForm();
    this.type = "act"
    this.id = this.activatedRoute.snapshot.params.id;
    this.ParkId = localStorage.getItem(AppConstant.localStorage.parkId);
    this.paymentStatus = 'all';
    this.getMeetingRoomByPark(this.ParkId, this.paymentStatus);
    // const customUrl = `/facility/facility-detail/${this.activatedRoute.snapshot.params.id}`
    // const route = this.sideNavService.routingChunks({ name: 'Facility Booking', customUrl: customUrl });
    // this.appStateSrv.setSideNavState(route);
  }

  /**
   * Fetches the list of meeting rooms for a given park based on the payment status.
   * It separates the meeting rooms into two lists: one for rooms under maintenance and one for rooms not under maintenance.
   * 
   * @param ParkId - The ID of the park for which to fetch meeting rooms.
   * @param paymentStatus - The payment status to filter the meeting rooms.
   * 
   * @remarks
   * - Calls the `getAllParkMeetingRooms` method from `meetingService` to fetch the meeting rooms.
   * - Filters the fetched meeting rooms into two lists: `MeetingRoomList` for rooms not under maintenance and `MeetingRoomListUnderMaintaince` for rooms under maintenance.
   * - Sets `isLoaded` to true after the fetch operation is complete.
   * - Logs the list of meeting rooms not under maintenance to the console.
   * - Displays a toast message if the fetch operation fails.
   * 
   * @returns void
   */
  getMeetingRoomByPark(ParkId: string, paymentStatus: string) {
    const parkTenantId: string | null = null;
    this.meetingService.getAllParkMeetingRooms(ParkId, paymentStatus, parkTenantId).subscribe(
      (res: any) => {
        if (res?.list.length > 0) {
          this.MeetingRoomList = res?.list.filter((x: any) => x.isUnderMaintenance == false || x.isUnderMaintenance == null);
          this.MeetingRoomListUnderMaintaince = res?.list.filter((x: any) => x.isUnderMaintenance == true);
        } else {
          this.MeetingRoomList = [];
          this.MeetingRoomListUnderMaintaince = [];
        }
        console.log(this.MeetingRoomList);
        this.isLoaded = true;
      },
      (error) => {
        console.error('Failed to fetch meeting rooms:', error);
        this.appStateSrv.showToast('Failed to fetch meeting rooms. Please try again later.');
        this.isLoaded = true;
      }
    );
  }

  selectType(type) {
    console.log(type.target.value)
    this.type = type.target.value;
    if (type.target.value == 'act') {
      this.actProp = true;
      this.underMaintainance = false;
    } else {
      this.actProp = false;
      this.underMaintainance = true;
    }
  }

  openDrawer(id, item) {
    $('#' + id).find('.drawer-container').toggle();
  }

  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openModal(id, roomname) {
    this.open(this.content);
    this.MeetingRoomId = id;
    this.meetingRoomName = roomname;
  }

  DeleteMeetingRoom() {
    this.deleteMeetingRoomMethod(this.MeetingRoomId, this.meetingRoomName);
  }

  /**
   * Deletes a meeting room by its ID.
   * 
   * This method sets the payment status to 'all' and constructs a request body
   * containing the meeting room ID. It then calls the `deleteParkMeetingRoom` 
   * method of the `meetingService` to delete the specified meeting room. 
   * Upon successful deletion, it refreshes the list of meeting rooms by 
   * calling `getMeetingRoomByPark` with the current park ID and payment status.
   * 
   * @param meetingRoomId - The ID of the meeting room to be deleted.
   */
  deleteMeetingRoomMethod(meetingRoomId, meetingRoomName) {
    localStorage.setItem("viewMeetingRoomName", meetingRoomName);
    this.paymentStatus = 'all';
    const body = {
      parkMeetingRoomId: meetingRoomId
    }
    this.meetingService.deleteParkMeetingRoom(body).subscribe((res) => {
      if (res.isValid) {
        this.getMeetingRoomByPark(this.ParkId, this.paymentStatus);
      } else {
        this.route.navigate(['meeting-room/details-meeting-room'], {
          queryParams: { id: meetingRoomId },
        });
      }
    },
      (error) => {
        console.error('Failed to delete meeting room:', error);
        // Optionally show a user-friendly message
      });
  }

  navigateToEdit(id) {
    this.route.navigate(['meeting-room/create-meeting-room'], { queryParams: { meetingRoomId: id } })
  }


  onClickedOutside(e: Event) {
    // console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  goToDetailsPage(parkMeetingRoomId) {
    if (parkMeetingRoomId != null) {
      this.route.navigate(['meeting-room/details-meeting-room'], {
        queryParams: { id: parkMeetingRoomId },
      });
    }
  }
}